import React from 'react';
import { Grid, GridRow, GridColumn } from "semantic-ui-react";

import pCMS from "../../../../img/AboutDarts/SDC-content-management-system.png";
import pAG from "../../../../img/AboutDarts/SDC-active-game-score.png";
import pLT from "../../../../img/AboutDarts/SDC-league-table-page.png";
import pSc from "../../../../img/AboutDarts/SDC-scorring-page.png";
import pLS from "../../../../img/AboutDarts/SDC-live-score-page.png";
import pSt from "../../../../img/AboutDarts/SDC-csv-stats.png";

const AboutDartsPages: React.FC = () => {
    let counter = 1;
    return (
        <Grid>
            <GridRow>
                <GridColumn width={8}>
                    <h3>{counter++}. Scoring page</h3>
                    <p>allows to perform scoring. It shows dartboard, legs, rounds in current leg and timeline.</p>
                    <p>
                        <a href={pSc} target="_blank" rel="noreferrer">
                            <img src={pSc} alt="Scoring" width="320px" />
                        </a>
                    </p>
                </GridColumn>
                <GridColumn width={8}>
                    <h3>{counter++}. Active game</h3>
                    <p>usually displayed on the main board in the gaming area.</p>
                    <p>
                        <a href={pAG} target="_blank" rel="noreferrer">
                            <img src={pAG} alt="CMS" width="320px" />
                        </a>
                    </p>
                </GridColumn>
            </GridRow>
            <GridRow>
                <GridColumn width={8}>
                    <h3>{counter++}. Live Score - game dashboard</h3>
                    <p>shows scores, shoots, statistics, timelines,</p>
                    <p>allows to download game picture after game end.</p>
                    <p>
                        <a href={pLS} target="_blank" rel="noreferrer">
                            <img src={pLS} alt="CMS" width="320px" />
                        </a>
                    </p>
                </GridColumn>
                <GridColumn width={8}>
                    <h3>{counter++}. League table</h3>
                    <p>players achievements in tournament,</p>
                    <p>can be downloaded as a picture, displayed in your video stream.</p>
                    <p>
                        <a href={pLT} target="_blank" rel="noreferrer">
                            <img src={pLT} alt="CMS" width="320px" />
                        </a>
                    </p>
                </GridColumn>
            </GridRow>
            <GridRow>
                <GridColumn width={8}>
                    <h3>{counter++}. Content Management System</h3>
                    <p>allows you to controll games, tournaments, players, your company users, broadcast listeners.</p>
                    <p>
                        <a href={pCMS} target="_blank" rel="noreferrer">
                            <img src={pCMS} alt="CMS" width="320px" />
                        </a>
                    </p>
                </GridColumn>
                <GridColumn width={8}>
                    <h3>{counter++}. Statistics</h3>
                    <p>allows you to download stats in CSV format for your next analytics.</p>
                    <p>
                        <a href={pSt} target="_blank" rel="noreferrer">
                            <img src={pSt} alt="CMS" width="320px" />
                        </a>
                    </p>
                </GridColumn>
            </GridRow>
        </Grid>
    );
}

export default AboutDartsPages;